module.exports = __webpack_public_path__ + "static/media/mobileApp.deea925d.png";